import { cn } from '@/lib/utils';
import { FC, HTMLAttributes } from 'react';

export const InputContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => {
  return (
    <div
      className={cn(
        `bg-secondary-std text-primary-std border-primary-std focus-within:ring-primary-600 relative flex w-full items-center rounded-lg shadow-sm ring-1 ring-inset ring-gray-200 focus-within:ring-2 dark:bg-white dark:bg-opacity-5 dark:ring-gray-700`,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
